import * as React from 'react';
import { Link } from 'react-router-dom';
import { Svg } from '../Svg';

interface IHeaderLinkProps {
  isActive: boolean;
  label: string;
  link: string;
  src: string;
}

export const HeaderLink: React.SFC<IHeaderLinkProps> = (props) => {
  const { isActive, label, link, src } = props;
  return (
    <Link to={link}>
      <div
        className={`d-flex flex-column justify-content-around align-items-center px-1 py-1 ${
          isActive ? 'bg-light' : ''
        }`}
      >
        <div
          className='d-flex justify-content-around align-items-center rounded-circle bg-primary'
          style={{ height: '60px', width: '60px' }}
        >
          <Svg width={36} fill='white' src={src} />
        </div>
        <span className='mt-1'>{label}</span>
      </div>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Header/HeaderLink.tsx